@if (initialized) {
  <app-global-layout>
    <router-outlet />
  </app-global-layout>

  <!-- overlays/ modals/ toasts/ notifications etc. -->
  <ag1-toast-notification class="relative z-50" />
  <p-confirmdialog />
  <p-toast />
  <ag-notifications-and-alerts />
}
<ng-template agModalHost />
